/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S6_P1Inputs */

const en_guide_json_syntax_errors_s6_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you encounter a JSON parsing error, try these steps:`)
};

const ko_guide_json_syntax_errors_s6_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 파싱 오류가 발생하면 다음 단계를 시도해 보세요:`)
};

const ja_guide_json_syntax_errors_s6_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONパースエラーが発生した場合は、以下の手順を試してください：`)
};

/**
* | output |
* | --- |
* | "When you encounter a JSON parsing error, try these steps:" |
*
* @param {Guide_Json_Syntax_Errors_S6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s6_p1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s6_p1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s6_p1(inputs)
	return ja_guide_json_syntax_errors_s6_p1(inputs)
});